<!--
 * @Description: 复盘
 * @Author: chenguobiao
 * @Date: 2021-08-01 17:36:17
 * @LastEditTime: 2022-11-12 22:10:07
 * @LastEditors: chenguobiao
-->
<template>
  <div class="grading-replay-page flex flex-col">
    <common-header selected="user" />
    <div class="grading-replay-page__content flex flex-col items-center" v-if="question.uid">
      <chess-question v-if="['national_iconic', 'ai'].includes(questionType)" ref="chessQuestionRef" :questionType="questionType" :question="question" :pauseFlag="pause.flag" :key="question.uid"></chess-question>
      <choice-question v-else ref="choiceQuestionRef" :questionType="questionType" :question="question" :key="question.uid"></choice-question>
      <div class="buttons flex">
        <template v-if="['national_iconic', 'singel_selection', 'multi_selection', 'true_or_false'].includes(questionType)">
          <next-option-button txt='下一题' @handleClick="next" v-if="!lastQuestion"></next-option-button>
          <submit-option-button txt='重新复盘' @handleClick="handleNextGame" v-else></submit-option-button>
        </template>
        <template v-else>
          <pause-option-button v-if="nextStepFlag" :txt='pause.flag ? "播放" : "暂停"' @handleClick="handlePause"></pause-option-button>
          <last-step-option-button v-if="pause.flag" txt='上一步' @handleClick="handleLastStep"></last-step-option-button>
          <next-step-option-button v-if="pause.flag && nextStepFlag" txt='下一步' @handleClick="handleNextStep"></next-step-option-button>
          <recovery-option-button v-if="pause.flag && !nextStepFlag" txt='复原' @handleClick="handleRecovery"></recovery-option-button>
          <next-game-option-button :txt='lastQuestion ? "重新复盘" : "下一局"' @handleClick="handleNextGame"></next-game-option-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { gradingAPI } from '@/apis'
import { WS_GAME_CONFIGS } from '@/config/const'
import { ChessQuestion, ChoiceQuestion, OptionButton } from './components'
import CommonHeader from '@/render/components/common/header'
import Chess from 'chess.js'
import store from 'store'
const newGame = new Chess()
export default {
  name: 'GradingReplay',
  components: {
    CommonHeader,
    ChessQuestion,
    ChoiceQuestion,
    NextOptionButton: OptionButton,
    SubmitOptionButton: OptionButton,
    PauseOptionButton: OptionButton,
    LastStepOptionButton: OptionButton,
    NextStepOptionButton: OptionButton,
    RecoveryOptionButton: OptionButton,
    NextGameOptionButton: OptionButton,
  },
  data() {
    return {
      questionList: [],
      questionIdx: 0,
      question: {},
      lastQuestion: false,
      gameStep: 0,
      pause: {
        step: 0,
        fen: '',
        flag: false
      },
      pauseFlag: false,
      switchFlag: false
    }
  },
  computed: {
    ...mapGetters('replay', ['nextStepFlag']),
    questionType() { // 1、国际象棋战术题 2、普通提 3、国际象棋实战对决
      return this.question.typeCode
    },
  },
  watch: {
    '$route.query.testLogUid': {
      immediate: true,
      handler(testLogUid) {
        this.getUserTestQuestion(testLogUid)
      }
    }
  },
  provide() {
    return {
      timeOver: this.timeOver
    }
  },
  methods: {
    async getUserTestQuestion(testLogUid) {
      let result = await gradingAPI.getUserTestQuestion({ testLogUid })
      this.questionList = result.data ? result.data.sort((prev, next) => {
        return new Date(prev.createTime) - new Date(next.createTime)
      }) : []
      this.getQuestion()
    },
    initGameConfig() {
      let gameConfig = store.get(WS_GAME_CONFIGS)
      gameConfig = { ...gameConfig, ...{ questionType: this.questionType } }
      if (['national_iconic', 'ai'].includes(this.question.typeCode)) {
        newGame.load(this.question.fen)
        const playerTurn = newGame.turn()
        gameConfig = { ...gameConfig, ...{ replay: true, player_turn: playerTurn || 'w', player_turn_color: playerTurn === 'w' ? 'white' : 'black', other_side_turn: playerTurn === 'w' ? 'b' : 'w' } }
      }
      store.set(WS_GAME_CONFIGS, gameConfig)
    },
    getQuestion() {
      const question = this.questionList[this.questionIdx]
      question.answerList = question.answerList ? question.answerList.sort((prev, next) => {
        return prev.number.localeCompare(next.number)
      }) : []
      this.question = question
      this.$store.commit('replay/setNextStepFlag', true)
      this.$store.commit('grading/setCurrQuestion', this.question)
      this.initGameConfig()
      if (this.questionIdx >= this.questionList.length - 1) {
        this.lastQuestion = true
      }
      if (question.typeCode === 'ai') {
        const question = this.question
        newGame.load_pgn(question.userAnswer)
        this.$nextTick(() => {
          this.autoPlayGame()
        })
      }
    },
    next() {
      if (this.lastQuestion) return
      this.questionIdx += 1
      if (this.questionIdx >= this.questionList.length - 1) {
        this.lastQuestion = true
      }
      this.getQuestion()
    },
    timeOver() {
    },
    autoPlayGame() { // 国际象棋实战对决自动播放
      const history = newGame.history({ verbose: true })
      this.switchFlag = false
      const callback = () => {
        setTimeout(() => {
          if (!this.switchFlag && !this.pause.flag && this.gameStep < history.length) {
            this.moveGame()
            this.gameStep += 1
            callback()
          } else {
            return false
          }
        }, 1000)
      }
      callback()
    },
    handleLastStep: _.throttle(function() {
      if (this.gameStep === 0 || !this.pause.flag) return
      const { game, board } = this.$refs.chessQuestionRef.$refs.chessRef
      game.undo()
      board.position(game.fen())
      if (this.nextStepFlag) this.gameStep -= 1
    }, 500),
    handleNextStep: _.throttle(function() {
      if (!this.pause.flag || !this.nextStepFlag) return
      if (this.moveGame()) {
        this.gameStep += 1
      }
    }, 500),
    handleRecovery() {
      if (!this.pause.flag) return
      const { game, board } = this.$refs.chessQuestionRef.$refs.chessRef
      const fen = this.pause.fen
      const pgn = this.pause.pgn
      game.load(fen)
      game.load_pgn(pgn)
      board.position(fen, false)
      this.pause.flag = true
      this.gameStep = this.pause.step
      this.$store.commit('replay/setNextStepFlag', true)
    },
    handlePause() {
      const pauseFlag = this.pause.flag
      if (pauseFlag) {
        this.pause.flag = false
        this.autoPlayGame()
      } else {
        const { game } = this.$refs.chessQuestionRef.$refs.chessRef
        this.pause.step = this.gameStep
        this.pause.flag = true
        this.pause.fen = game.fen()
        this.pause.pgn = game.pgn()
        this.$store.commit('replay/setNextStepFlag', true)
      }
    },
    handleNextGame() {
      this.switchFlag = true
      this.pause.flag = false
      this.gameStep = 0
      if (this.lastQuestion) {
        this.questionIdx = -1
        this.lastQuestion = false
      }
      this.next()
    },
    moveGame() {
      const { game, board } = this.$refs.chessQuestionRef.$refs.chessRef
      const history = newGame.history({ verbose: true })
      const gameStep = this.gameStep
      if (gameStep >= history.length || gameStep < 0) return false
      const step = history[this.gameStep]
      game.move(step)
      board.move(step)
      board.position(game.fen())
      return true
    }
  },
}
</script>

<style lang="scss" scoped>
  .grading-replay-page {
    height: 100vh;
    &__content {
      flex: 1;
      background: url('../../assets/images/grading/bg.png') no-repeat left top;
      background-size: 100% 100%;
    }
    .buttons {
      padding: val(27) 0;
      &.small {
        ::v-deep {
          .option-button {
            width: val(165.2);
            &__text {
              font-size: val(20);
            }
          }
        }
      }
    }
  }
</style>
